// Stripe Configuration
// Uses test keys by default, switches to production in production builds

import { stripeConfig, localeConfig, configHelpers } from './app';

// Stripe Publishable Keys
// Set via REACT_APP_STRIPE_PUBLISHABLE_KEY environment variable
export const STRIPE_PUBLISHABLE_KEY = stripeConfig.publishableKey;

// Stripe Price IDs
export const STRIPE_PRICE_IDS = stripeConfig.priceIds;

// Subscription tiers mapping
export const STRIPE_PLANS = {
  lite: {
    name: 'Lite',
    priceId: STRIPE_PRICE_IDS.lite,
    amount: stripeConfig.pricing.lite,
    currency: localeConfig.currency.toLowerCase(),
  },
  premium: {
    name: 'Premium',
    priceId: STRIPE_PRICE_IDS.premium,
    amount: stripeConfig.pricing.premium,
    currency: localeConfig.currency.toLowerCase(),
  },
};

// Format amount from pence to currency string
export const formatAmount = configHelpers.formatCurrency;

